import axios from 'axios';
//require('dotenv').config({ path: `.env.${process.env.NODE_ENV}` })

var api_URL= 'http://localhost:7001'
if (process.env.NODE_ENV === "development") {
  api_URL = 'http://localhost:7001'
}
else if (process.env.NODE_ENV === "production") {
  api_URL = 'https://apiclient.newworld.center'
}
const instance = axios.create({
  baseURL: api_URL
});

// const instance = axios.create({
//     baseURL: 'http://localhost:7001'
// });
console.log(process.env.NODE_ENV);
const AUTH_TOKEN = "123"
const System = "Betner"
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

export default instance;
